import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Navbar from "./Navbar";
import Footer from "./Footer";
import CartDrawer from "./CartDrawer";
import { imgUrl } from "../admin/adminApi";
import { CalendarDays, ArrowRight, ArrowLeft, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BlogList = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  useEffect(() => { window.scrollTo(0, 0); axios.get(`${API}/blogs`).then((r) => setBlogs(r.data)).catch(() => {}).finally(() => setLoading(false)); }, []);
  return (
    <>
      <Navbar />
      <main className="min-h-[60vh] max-w-7xl mx-auto px-4 md:px-6 lg:px-12 py-12 md:py-16">
        <p className="text-primary font-semibold tracking-wide uppercase text-sm">Our Blog</p>
        <h1 className="font-display text-3xl md:text-4xl font-bold text-gray-900 mt-2">Beauty Tips & Stories</h1>
        <div className="w-20 h-1 bg-accent rounded-full mt-4" />
        {loading ? <div className="py-20 text-center"><Loader2 className="w-8 h-8 animate-spin text-primary mx-auto" /></div> : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
            {blogs.map((p) => (
              <button key={p.id} onClick={() => navigate(`/blog/${p.slug || p.id}`)} className="svc-card text-left group bg-white rounded-2xl overflow-hidden ring-1 ring-black/5 shadow-sm hover:shadow-xl flex flex-col">
                <div className="img-zoom-wrap h-48 overflow-hidden"><img src={imgUrl(p.image)} alt={p.title} className="img-zoom w-full h-full object-cover" /></div>
                <div className="p-5 flex flex-col flex-1">
                  <div className="flex items-center gap-2 text-xs text-gray-500"><span className="bg-primary/10 text-primary font-semibold px-2.5 py-1 rounded-full">{p.category}</span><span className="flex items-center gap-1"><CalendarDays className="w-3.5 h-3.5" /> {p.date}</span></div>
                  <h3 className="font-display text-lg font-bold text-gray-900 mt-3 group-hover:text-primary transition-colors">{p.title}</h3>
                  <p className="text-gray-600 mt-2 text-sm flex-1 line-clamp-3">{p.excerpt}</p>
                  <span className="text-primary font-semibold mt-4 flex items-center gap-1 text-sm">Read more <ArrowRight className="w-4 h-4" /></span>
                </div>
              </button>
            ))}
          </div>
        )}
      </main>
      <Footer />
      <CartDrawer />
    </>
  );
};

export const BlogDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => { window.scrollTo(0, 0); axios.get(`${API}/blogs/${id}`).then((r) => setBlog(r.data)).catch(() => {}).finally(() => setLoading(false)); }, [id]);
  return (
    <>
      <Navbar />
      <main className="min-h-[60vh] max-w-3xl mx-auto px-4 md:px-6 py-12 md:py-16">
        {loading ? <div className="py-20 text-center"><Loader2 className="w-8 h-8 animate-spin text-primary mx-auto" /></div> : !blog ? <div className="py-20 text-center text-gray-500">Blog not found.</div> : (
          <article>
            <button onClick={() => navigate("/blog")} className="flex items-center gap-1 text-sm text-primary font-medium mb-5 hover:underline"><ArrowLeft className="w-4 h-4" /> All posts</button>
            <div className="flex items-center gap-2 text-xs text-gray-500"><span className="bg-primary/10 text-primary font-semibold px-2.5 py-1 rounded-full">{blog.category}</span><span className="flex items-center gap-1"><CalendarDays className="w-3.5 h-3.5" /> {blog.date}</span></div>
            <h1 className="font-display text-3xl md:text-4xl font-bold text-gray-900 mt-3">{blog.title}</h1>
            {blog.image ? <img src={imgUrl(blog.image)} alt={blog.title} className="w-full rounded-2xl mt-6 object-cover max-h-96" /> : null}
            <div className="mt-6 text-gray-700 leading-relaxed whitespace-pre-line">{blog.content}</div>
          </article>
        )}
      </main>
      <Footer />
      <CartDrawer />
    </>
  );
};

export default BlogList;
